import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { shouldReportErrorMonitor } from '../../Challenge/helpers/shouldReportErrorMonitor';
import { handleError } from '../../../ErrorHandler/errorHandlerPropsMap';
import { getInstance } from '../../../../services/instance';

export default async function (
  flowAPI: ControllerFlowAPI,
  personaId: string,
  programId: string,
) {
  const instanceFromUrl = getInstance(flowAPI);
  const { withErrorHandler } = flowAPI.errorHandler;

  try {
    await withErrorHandler(
      async () => {
        return flowAPI.httpClient.get(
          `/_api/online-programs-ai-helper-serverless/pair`,
          {
            params: {
              key: programId,
            },
            headers: {
              Authorization: instanceFromUrl,
            },
          },
        );
      },
      {
        errorCodesMap: {
          applicationError: {},
        },
      },
    );
  } catch (error) {
    const resolvedError = flowAPI.errorHandler.getResolvedError(error);

    handleError({
      error,
      resolvedError,
      context: 'AIChatPair',
      preventErrorMonitorReport: !shouldReportErrorMonitor(error),
    });
  }
}
